<template>
  <BModal size="md" body-class="p-5 rounded-lg" :visible="visible" hide-header hide-footer @hide="$emit('close', true)">
    <div class="text-center">
      <h3 class="font-weight-bold gradient-text mb-3">Request Access To Shop!</h3>
      <div class="shadow border rounded p-5 mb-2">
        <img
          :style="{
            height: '80px',
            width: '80px',
            borderRadius: '50%',
            border: '1px solid #ddd',
          }"
          class="mb-3 d-block mx-auto shadow-sm"
          :src="sellerCompany.logoLink"
        />

        <p class="font-weight-bold text-dark mb-2">Before you can shop you will need to get this sellers approval.</p>
        <BushelBtn class="my-3 px-4 py-2" variant="success" @click="$emit('requestAccess', true)"> Request Access </BushelBtn>
      </div>
      <p class="text-sm text-dark mb-2">
        If you close this window without requesting access you will be unable to shop. You can bring this window back up with a refresh of this page.
      </p>
      <BushelBtn class="btn-sm" outline variant="primary" @click="$emit('close', true)"> Close </BushelBtn>
    </div>
  </BModal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    sellerCompany: {
      type: Object,
      default: null,
      required: true,
    },
  },
  emits: ["close", "requestAccess"],
  data() {
    return {
      industry: "cannabis",
    };
  },
};
</script>
<style>
.gradient-text {
  background: linear-gradient(to right, var(--success), var(--primary) 60%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
